import React from 'react';

export function QuizCompletedSVG({ className = '' }: { className?: string }) {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className={className}
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7825_1871)">
                <g clipPath="url(#clip1_7825_1871)">
                    <path
                        d="M13 17.4L14.8 19.2L18 14.5"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M21 11H9C7.89543 11 7 11.8954 7 13V21C7 22.1046 7.89543 23 9 23H21C22.1046 23 23 22.1046 23 21V13C23 11.8954 22.1046 11 21 11Z"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M7 13H3C1.89543 13 1 12.1046 1 11V3C1 1.89543 1.89543 1 3 1H15C16.1046 1 17 1.89543 17 3V10.9"
                        strokeWidth="1.5"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <circle cx="8.8252" cy="5.9375" r="2.25" strokeWidth="1.5" />
                    <line
                        x1="9.37569"
                        y1="6.51874"
                        x2="11.2607"
                        y2="8.40379"
                        strokeWidth="1.4"
                        strokeLinecap="round"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0_7825_1871">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
                <clipPath id="clip1_7825_1871">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
